import ApplicationSerializer from 'eflex/serializers/application';

export default class EvisionConfigSerializer extends ApplicationSerializer {
  attrs = {
    fileRetention: {
      embedded: 'always',
    },
    namingConvention: {
      embedded: 'always',
    },
  };
}
